import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import global from "./global/index";
import user from "./user/index";
import menu from "./menu/index";
import wallet from "./wallet/index";
import tutorial from "./tutorials/index";
import localstorage from "./localstorage";
import local from "./qrInfo/index";
import locals from "./locals";
import smsNumbersIndex from "./smsNumbers/index";
import voiceOperators from "./smsNumbers/voiceOperators";
import socialOperators from "./smsNumbers/socialOperators";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,
    global,
    user,
    menu,
    wallet,
    tutorial,
    localstorage,
    local,
    locals,
    smsNumbersIndex,
    voiceOperators,
    socialOperators,
  },
});
